<template>
  <div>
    <h3></h3>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row
      v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="minerName" label="矿机名称">
      </el-table-column>
      <!-- <el-table-column align="center" label="类型" min-width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.minerType == 'normal'">普通用户</div>
          <div v-if="scope.row.minerType == 'primary'">股东</div>
          <div v-if="scope.row.minerType == 'partner'">合伙人</div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="totalCount" label="购买次数">
      </el-table-column>
      <el-table-column align="center" prop="userCount" label="购买人数">
      </el-table-column>
      <el-table-column align="center" prop="totalValue" label="购买总U">
      </el-table-column>
      <!-- <el-table-column align="center" prop="remain" label="剩余在售数量" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="total" label="销售总数">
      </el-table-column> -->
      <!-- <el-table-column align="center" prop="offset" label="已减少数量">
        <template slot-scope="scope">
          <div>{{ scope.row.offset }}</div>
          <el-button size="mini" type="success" @click="onOffset(scope.row)">设置</el-button>
        </template>
      </el-table-column> -->
      
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.minerStatus == 'waiting'">待售</div>
          <div v-if="scope.row.minerStatus == 'ongoing'">在售</div>
          <div v-if="scope.row.minerStatus == 'sellout'" class="red"><el-tag type="danger">售罄</el-tag></div>
          <div v-if="scope.row.minerStatus == 'discuss'">洽谈中</div>
          <div v-if="scope.row.minerStatus == 'close'">关闭</div>
          <el-button v-if="scope.row.minerStatus != 'sellout'" size="mini" type="primary" @click="onStatus(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="修改减少数量" :visible.sync="offsetVisible" width="30%" @click="offsetVisible = false">
      <el-form label-width="120px">

        <el-form-item label="在售数量">
          {{remain || 0}}
        </el-form-item>
        <el-form-item label="减少数量" prop="offset">
          <el-input type="number" size="small" v-model="offset" auto-complete="off" placeholder="请输入减少数量" onkeyup="this.offset=this.offset.replace(/\D|^0/g)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="offsetVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitOffset">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改状态" :visible.sync="statusVisible" width="30%" @click="statusVisible = false">
      <el-form label-width="120px">
        <el-select size="small" v-model="status" placeholder="请选择状态">
          <el-option v-for="item in statusType" :label="item.name" :value="item.value" :key="item.value"></el-option>
        </el-select>
        <!-- <el-form-item label="减少数量" prop="offset">
          <el-input type="number" size="small" v-model="offset" auto-complete="off" placeholder="请输入减少数量"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="statusVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitStatus">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { sumsList, updateOffset , updateStatus } from '../../api/userMG'
export default {
  data() {
    return {
      loading: false, //是显示加载
      listData: [], //用户数据
      offsetVisible: false,
      statusVisible:false,
      status:null,
      offset: '1',
      minerId:null,
      statusType:[
        {name:'待售',value:'waiting'},
        {name:'在售',value:'ongoing'},
        {name:'售罄',value:'sellout'},
        {name:'洽谈中',value:'discuss'},
        {name:'关闭',value:'close'},
      ],
      remain:null
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata() {
      this.loading = true
      sumsList()
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    onOffset(row) {
      this.offsetVisible = true
      this.minerId = row.minerId
      this.remain = row.remain
      this.offset = '1'
      // row.time
    },
    onStatus(row) {
      this.statusVisible = true
      this.minerId = row.minerId
      this.offset = null
      this.status = row.minerStatus
      // row.time
    },
    submitOffset() {
      // console.log(this.offset)
      if(this.offset == '' || !this.offset){
        this.$message({
          type: 'warning',
          message: '请输入大于或等于1的正整数'
        })
        return
      }
      
      if(parseInt(this.offset) > this.remain){
        this.$message({
          type: 'warning',
          message: '减少矿机数量大于在售数，操作失败'
        })
        return
      }
      this.loading = true
      this.$confirm('确定要修改吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          updateOffset({ "offset": parseInt(this.offset), "minerId": this.minerId }).then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.loading = false
              this.offsetVisible = false
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.getdata()
            }
          })

        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })

    },
    submitStatus() {
      this.loading = true
      this.$confirm('确定要修改吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          updateStatus({ "status": this.status, "minerId": this.minerId }).then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.loading = false
              this.statusVisible = false
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.getdata()
            }
          })

        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })

    },
  }
}
</script>
  
<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/miner/Minersdata.vue